import script from "./sortScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./sortScreen.vue?vue&type=script&setup=true&lang=js"

import "./sortScreen.vue?vue&type=style&index=0&id=35768582&lang=scss&scoped=true"

import exportComponent from "F:\\tubida\\tbd_screen_client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35768582"]])

export default __exports__